import type { WidgetOverride } from '@/lib/api';

import type { WidgetConfig } from './dashboard.types';

export function resolveWidgets(
  base: WidgetConfig[],
  overrides?: Record<string, WidgetOverride>
): WidgetConfig[] {
  if (!overrides) return base.filter((widget) => widget.visible !== false);

  const knownIds = new Set(base.map((w) => w.id));
  for (const id of Object.keys(overrides)) {
    if (!knownIds.has(id)) {
      console.warn(`[dashboard] /settings override for unknown widget "${id}" — ignoring`);
    }
  }

  const resolved: WidgetConfig[] = [];
  for (const widget of base) {
    const override = overrides[widget.id];
    // The override decides when it speaks; otherwise the widget's own default
    // does, and a widget that declares neither is visible.
    if (!(override?.visible ?? widget.visible ?? true)) continue;
    if (!override) {
      resolved.push(widget);
      continue;
    }
    resolved.push({
      ...widget,
      position: { ...widget.position, ...override.position },
    });
  }
  return resolved;
}
